import React, { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ArrowBackIos } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Header } from '../../../../components/header/header';
import Strings from '../../../../i18n';
import { TooltipStyled } from '../../../locations/locationStyles';
import { ButtonIconStyled, TitleStyled } from '../../../devices/devicesStyles';
import { useGetSerialNumberByIdMutation } from '../../../../services/manufacture/manufactureService';
import { RightSideBar } from '../../../../components/layout/rightSideBar/rightSideBar';
import { viewRightSideBarEnum } from '../../../../constants/sidebarEnums';
import { EditSerialNumberSideBar } from '../../../../templates/manufacture/serialNumberTemplate/editSerialNumberSideBar/editSerialNumberSideBar';
import { CreateSerialNumberSideBar } from '../../../../templates/manufacture/serialNumberTemplate/createSerialNumberSideBar/createSerialNumberSideBar';
import { SearchSerialNumberTemplate } from '../../../../templates/manufacture/serialNumberTemplate/searchSerialNumberTemplate/searchSerialNumberTemplate';
import { ContainerStyled } from '../../../../components/layout/main/mainStyles';

export const SearchManufacturingSerialNumberView = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get('searchSerialNumber');
  const [openSideBarFor, setOpenSideBarFor] = useState<number | null>(null);
  const [openSideBar, setOpenSideBar] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);

  const [getSerialNumber, { isSuccess, data, isLoading }] =
    useGetSerialNumberByIdMutation();

  const reloadTable = () => {
    getSerialNumber(serialNumber ?? '');
    setSelectedItems([]);
    return {};
  };

  useEffect(() => {
    reloadTable();
  }, []);

  const handleRightSideBarMethod = (method: number) => {
    setOpenSideBarFor(method);
  };

  const switchComponentToShowRightSideBar = () => {
    switch (openSideBarFor) {
      case viewRightSideBarEnum.createPartNumber:
        return (
          <CreateSerialNumberSideBar
            reloadTable={reloadTable}
            setOpenSideBar={setOpenSideBar}
            openRightSideBarForMethod={handleRightSideBarMethod}
          />
        );
      case viewRightSideBarEnum.singlePartNumber:
        return (
          <EditSerialNumberSideBar
            serialNumber={selectedItems[0]}
            reloadTable={reloadTable}
            setOpenSideBar={setOpenSideBar}
            setUsersSelected={setSelectedItems}
            openRightSideBarForMethod={handleRightSideBarMethod}
          />
        );
      case viewRightSideBarEnum.multipleUserActivation:
      default:
        return null;
    }
  };

  useEffect(() => {
    if (selectedItems.length === 1) {
      setOpenSideBar(true);
      setOpenSideBarFor(viewRightSideBarEnum.singlePartNumber);
    } else if (selectedItems.length > 1) {
      setOpenSideBar(true);
      setOpenSideBarFor(viewRightSideBarEnum.multipleUserActivation);
    } else {
      setOpenSideBar(false);
    }
  }, [selectedItems]);

  return (
    <>
      <Header>
        <ContainerStyled>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <TitleStyled align="center">
                {Strings.manufacture.serialNumber.title}
              </TitleStyled>
            </div>
            <div className="col-4 text-right" />
          </div>
        </ContainerStyled>
      </Header>
      <SearchSerialNumberTemplate
        isLoading={isLoading}
        isSuccess={isSuccess}
        allSerialNumber={Array.isArray(data) ? data : [data]}
        openedSideBar={openSideBar}
        setOpenSideBar={setOpenSideBar}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />
      <RightSideBar
        open={openSideBar}
        onMenuClose={() => {
          setOpenSideBar(false);
        }}
      >
        {switchComponentToShowRightSideBar()}
      </RightSideBar>
    </>
  );
};
